import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/Account/Get', params)
    },
    getList: params => {
        return API.GET('/api/Account/List', params)
    },
    select: params => {
        return API.GET('/api/Account/select', params)
    },
    add: params => {
        return API.POST('/api/Account/Add', params)
    },
    addTeam: params => {
        return API.POST('/api/Account/AddTeam', params)
    },
    addHost: params => {
        return API.POST('/api/Account/AddHost', params)
    },
    edit: params => {
        return API.POST('/api/Account/Edit', params)
    },
    changePassword: params => {
        return API.POST('/api/Account/ChangePassword', params)
    },
    resetPassword: params => {
        return API.POST('/api/Account/ResetPassword', params)
    },
    delete: params => {
        return API.DELETE('/api/Account/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/Account/DeleteBatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/account.js